import React, { useContext } from "react";
import "./Services.css";
import Card from "../Card/Card";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import Resume from './ADNAN-SALEEM-CV.pdf';

const Services = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };

  return (
    <div className="services" id="services">
      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span style={{ color: darkMode ? "white" : "" }}>My Awesome</span>
        <span>services</span>
        <spane>
        Experienced React Native developer specializing in mobile app creation,
         Web3 decentralized wallets, and backend solutions. Proficient in Node.js, MongoDB, and Firebase,
          I develop apps that seamlessly bridge blockchain technology and user-friendly interfaces.
           From crafting crypto wallets to publishing on Android and the App Store, I bring your vision to life.
          <br />
         
        </spane>
        <a href={Resume} download>
          <button className="button s-button">Download CV</button>
        </a>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
      <div className="cards">
        {/* first card */}
        <motion.div
          initial={{ left: "10rem" }}
          whileInView={{ left: "10rem" }}
          transition={transition}
        >
          <Card
            emoji={HeartEmoji}
            heading={"Mobile App"}
            detail={"React Native, Api, Redux, Firebase Native Modules, In-App Purchase, App Publishing"}
          />
        </motion.div>
        {/* second card */}
        <motion.div
          initial={{ left: "11rem", top: "10rem" }}
          whileInView={{ left: "-5rem" }}
          transition={transition}
        >
          <Card
            emoji={Glasses}
            heading={"Web3"}
            detail={"Crypto Wallets, Dapps, decentralized wallet, Integrating smart contracts."}
          />
        </motion.div>
        {/* 3rd */}
        <motion.div
          initial={{ top: "25rem", left: "2rem" }}
          whileInView={{ left: "10rem" }}
          transition={transition}
        >
          <Card
            emoji={Humble}
            heading={"Backend"}
            detail={
              "Node.js, Express.js, SQLite, MongoDB, Firebase"
            }
            color="rgba(252, 166, 31, 0.45)"
          />
        </motion.div>
        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        ></div>
      </div>
    </div>
  );
};

export default Services;
